module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/EE-482da50d3e4580149de89700f210a198.png";